import { apiClient } from './apiService';

const analyticsService = {
  getAllAnalytics: async (timeRange = '30d') => {
    const response = await apiClient.get(`/api/analytics/all?timeRange=${timeRange}`);
    return response.data?.data || response.data;
  },

  getOverview: async (timeRange = '30d') => {
    const response = await apiClient.get(`/api/analytics/overview?timeRange=${timeRange}`);
    return response.data?.data || response.data;
  },

  getTrafficData: async (timeRange = '30d') => {
    const response = await apiClient.get(`/api/analytics/traffic?timeRange=${timeRange}`);
    return response.data?.data || response.data;
  },

  getDonationsData: async (timeRange = '30d') => {
    const response = await apiClient.get(`/api/analytics/donations?timeRange=${timeRange}`);
    return response.data?.data || response.data;
  },

  getContentData: async (timeRange = '30d') => {
    const response = await apiClient.get(`/api/analytics/content?timeRange=${timeRange}`);
    return response.data?.data || response.data;
  },

  getEventsData: async () => {
    const response = await apiClient.get(`/api/analytics/events`);
    return response.data?.data || response.data;
  }
};

export default analyticsService;
